<template>
    <FilterTableViewer 
    :search-on-column="searchOnColumn" 
    :data-handler="getProcessesMapped" 
    :raw-filter-config="rawFilterConfig"
    :actions="actions"
    :ignored-keys="ignoredKeys" />
</template>

<script setup>

import FilterTableViewer from '@/components/Automation/FilterTableViewer.vue';

import rawFilterConfig from '@/config/Filters/filterConfigProcess.json';
import { actions } from '@/config/Actions/processesActionsConfig';

import { getProcessesMapped } from '@/Services/Ressources/API/ProcessService';

const searchOnColumn = 'Name'

const ignoredKeys = new Set([
    'organizationUnitId',
    'ProcesKey',
]);

</script>